import { useDispatch } from "react-redux";
import { ModalBase } from "../../../../components/Modals/ModalBase";
import { gp_ap_Clear, gp_ap_SetSucursalesSeleccionadas } from "../../../../actions/gestion-producto/agregar-producto/agregarProducto.actions";
import { bindActionCreators } from "redux";
import { actionsGPAgregarProducto } from "../../../../actions/action-creators";

const ModalProductoCreated = (props: any) => {
    const dispatch = useDispatch();
    const actions = bindActionCreators(actionsGPAgregarProducto, dispatch);

    const aceptar = async () => {
        dispatch(gp_ap_Clear());
        dispatch(gp_ap_SetSucursalesSeleccionadas([]));
        await actions.gp_ap_getSucursales();
        if (props.onClose) props.onClose();
    }

    return (
        <ModalBase>
            <div className="modal-card">
                <div className="modal-content">
                    <div className="w-layout-hflex">
                        <h3 className="card-title l">¡Producto creado exitosamente!</h3>
                    </div>
                    <div className="form-separator"></div>
                    <div className="w-layout-hflex button-actions">
                        <button className="m button w-inline-block" onClick={aceptar}>
                            <div>Aceptar</div>
                        </button>
                    </div>
                </div>
            </div>
        </ModalBase>
    );
}
export default ModalProductoCreated;
